import { FunctionComponent } from "react";

import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import { EventForm } from "../EngagementEventPage/EventForm.tsx";

import { useEventFormForProject } from "./useEventFormForProject.ts";

export const ProjectEventModal: FunctionComponent = () => {
    const { engagementId, projectId, eventId } = useParams();
    const eventFormProps = useEventFormForProject(engagementId ?? "", projectId ?? "", eventId ?? "");

    return (
        <Modal
            isOpen={true}
            onClose={() => {
                window.history.back();
            }}
            size={"3xl"}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{`${eventFormProps.eventQuery.data?.eventId ? "Edit" : "Add"} Event`}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <EventForm {...eventFormProps} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
